import { getCompanyStorageKey } from '../tenantContext';
import { ParsedCommand } from './commandParser';

export interface VoiceCommandLogEntry {
  id: string;
  companyId: string;
  userId?: string;
  timestamp: number;
  transcript: string;
  intent: string;
  confidence: number;
  noisyEnvironment: boolean;
  language: string;
  success: boolean;
  error?: string;
}

const ANALYTICS_BUFFER_KEY = () => getCompanyStorageKey('voice:analytics:buffer');

function getBuffer(): VoiceCommandLogEntry[] {
  try {
    const raw = localStorage.getItem(ANALYTICS_BUFFER_KEY());
    if (!raw) return [];
    return JSON.parse(raw) as VoiceCommandLogEntry[];
  } catch (error) {
    return [];
  }
}

function persistBuffer(entries: VoiceCommandLogEntry[]) {
  try {
    localStorage.setItem(ANALYTICS_BUFFER_KEY(), JSON.stringify(entries.slice(-200)));
  } catch (error) {
  }
}

export function logVoiceCommand(
  companyId: string,
  params: {
    command: ParsedCommand;
    transcript: string;
    noisyEnvironment: boolean;
    language: string;
    userId?: string;
    success?: boolean;
    error?: string;
  }
) {
  const entry: VoiceCommandLogEntry = {
    id: `voice-${Date.now()}`,
    companyId,
    userId: params.userId,
    timestamp: Date.now(),
    transcript: params.transcript,
    intent: params.command.intent,
    confidence: params.command.confidence,
    noisyEnvironment: params.noisyEnvironment,
    language: params.language,
    success: params.success ?? params.command.intent !== 'unknown',
    error: params.error,
  };

  const buffer = getBuffer();
  buffer.push(entry);
  persistBuffer(buffer);

  return entry;
}

export function flushVoiceAnalytics(): VoiceCommandLogEntry[] {
  const buffer = getBuffer();
  persistBuffer([]);
  return buffer;
}
